import { AppleIcon, FacebookIcon, GoogleIcon } from '@karma/components/icons';

const DEFAULT_PROVIDERS = { google: GoogleIcon, facebook: FacebookIcon, apple: AppleIcon };

export const oauthProviders = Object.entries(DEFAULT_PROVIDERS);
